import { ExternalLink, Gift } from "lucide-react";

const AMAZON_LIST_URL = "https://www.amazon.com/registries/gl/guest-view/CJWHW5WWN0BJ";

export default function Wishlist() {
  return (
    <section id="wishlist" className="py-24 md:py-32 max-w-7xl mx-auto px-4 sm:px-6">
      <p className="font-sub text-xs tracking-[0.2em] uppercase font-bold text-purple-400 mb-3">The Registry</p>
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight uppercase mb-4">
        Chase's <span className="text-purple-400">Wish List</span>
      </h2>
      <p className="font-sub text-base md:text-lg text-zinc-400 max-w-2xl mb-12">
        Everything Chase needs for freshman year — dorm essentials, tech, gear, and more — lives
        on his official Amazon registry. Pick an item and it ships straight to him at school.
      </p>

      <div className="relative rounded-3xl bg-zinc-900 border border-purple-500/30 p-8 md:p-14 overflow-hidden">
        <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-purple-600/10 blur-3xl" />
        <div className="relative flex flex-col md:flex-row md:items-center gap-8 md:gap-14">
          <div className="w-20 h-20 rounded-2xl bg-purple-600/20 border border-purple-500/40 flex items-center justify-center flex-shrink-0">
            <Gift className="w-10 h-10 text-purple-400" />
          </div>
          <div className="flex-1">
            <h3 className="font-sub font-bold text-2xl text-white mb-2">Official Amazon Registry</h3>
            <p className="text-zinc-400 mb-6 max-w-xl">
              One list, kept up to date by the family. Items you purchase are marked off
              automatically so there are no duplicates — and everything delivers to Chase's
              campus mailbox.
            </p>
            <a
              href={AMAZON_LIST_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="amazon-wishlist-btn"
              className="inline-flex items-center gap-2 font-sub font-semibold bg-purple-600 hover:bg-purple-500 text-white px-8 py-4 rounded-full transition-colors duration-200 drop-shadow-[0_0_20px_rgba(147,51,234,0.5)] active:scale-95"
            >
              Shop the Registry <ExternalLink className="w-4 h-4" />
            </a>
            <p className="text-xs text-zinc-500 mt-4">Prefer a gift card instead? Scroll down — Chase loves those too. 💜</p>
          </div>
        </div>
      </div>
    </section>
  );
}
